import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import theme from 'theme/theme';

const Input = styled.input`
  box-sizing: border-box;
  width: 100%;
  padding: 10px 20px;
  border: 1px solid ${theme.colors.mediumLight};
  border-radius: 0;
  color: ${theme.colors.black};
  background: ${theme.colors.lighter};
  font-size: ${theme.fontSizes.default};
  outline-offset: -3px;
  &:focus {
    outline: none;
    border-color: ${theme.colors.medium};
  }
  &::placeholder {
    color: ${theme.colors.medium};
  }
  ${props =>
    props.hasError &&
    css`
      &,
      &:focus {
        border-color: ${theme.colors.primary};
      }
    `}
  ${props =>
    props.variant === 'ghost' &&
    css`
      border-color: transparent;
      &:hover {
        border-color: transparent;
      }
    `}
`;
Input.propTypes = {
  hasError: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'ghost']),
};
Input.defaulProps = {
  hasError: false,
  variant: 'default',
};

export default Input;
